import * as React from 'react'
import { DndProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import { ProjectGroupProps } from './types'
import useColumns from './use_columns'
import ColumnRow from './column_row'
import HiddenInputs from './hidden_inputs'
import I18n from '../../../libs/i18n'

interface Props {
  project_group: ProjectGroupProps
}

function ProjectGroupsColumnsInner({ project_group }: Props) {
  const {
    columns,
    visibleColumns,
    generateOptionId,
    moveColumn,
    updateColumn,
    removeColumn,
    addColumn,
    duplicateColumn,
  } = useColumns({ initialColumns: project_group.columns })

  return (
    <div className="project-groups-columns">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">{I18n.t('project_groups.columns_editor.title', { name: project_group.name })}</h5>
          <button type="button" className="btn btn-outline-primary btn-sm" onClick={addColumn}>
            <i className="fa fa-plus mr-1" />
            {I18n.t('project_groups.columns_editor.add_column')}
          </button>
        </div>
        <div className="card-body">
          {visibleColumns.length === 0 ? (
            <p className="text-muted">{I18n.t('project_groups.columns_editor.no_columns')}</p>
          ) : (
            visibleColumns.map((column, index) => (
              <ColumnRow
                key={column.id}
                column={column}
                index={index}
                moveColumn={moveColumn}
                updateColumn={updateColumn}
                removeColumn={removeColumn}
                duplicateColumn={duplicateColumn}
                generateOptionId={generateOptionId}
                system_column_keys={project_group.system_column_keys}
                required_eligible_system_keys={project_group.required_eligible_system_keys}
              />
            ))
          )}
        </div>
      </div>
      <HiddenInputs columns={columns} />
    </div>
  )
}

export default function ProjectGroupsColumns(props: Props) {
  return (
    <DndProvider backend={HTML5Backend}>
      <ProjectGroupsColumnsInner {...props} />
    </DndProvider>
  )
}
